(function backgroundImages() {
  const initialized = new WeakSet();

  function applyBackground(element) {
    const desktop = element.getAttribute('data-background-image');
    const mobile = element.getAttribute('data-background-image-mobile');
    let background;

    if (window.innerWidth <= 768) {
      if (!mobile) {
        element.style.backgroundImage = '';
        return;
      }

      background = mobile;
      element.style.backgroundSize = 'cover';
    } else {
      background = desktop;
      element.style.backgroundSize = 'contain';
    }

    if (!background) return;
    element.style.backgroundImage = `url('${background}')`;
    element.style.backgroundPosition = 'center';
    element.style.backgroundRepeat = 'no-repeat';
  }

  function initializeBackgroundImages(root = document) {
    const elements = [];

    if (root.matches?.('[data-background-image]')) elements.push(root);
    root.querySelectorAll?.('[data-background-image]').forEach((element) => elements.push(element));

    elements.forEach((element) => {
      if (!initialized.has(element)) {
        initialized.add(element);
        const desktop = element.getAttribute('data-background-image');
        const mobile = element.getAttribute('data-background-image-mobile');
        if (desktop) Theme.Helpers.preload_image(desktop);
        if (mobile) Theme.Helpers.preload_image(mobile);
      }

      applyBackground(element);
    });
  }

  window.initializeBackgroundImages = initializeBackgroundImages;
  initializeBackgroundImages();
  window.addEventListener('resize', Theme.Helpers.debounce(() => initializeBackgroundImages(), 150));
})();
